import React, { memo, useState, useEffect } from "react";

import { Icon } from "src/primitives";
import { getProviderLogo } from "src/utils";

import styles from "./style.css";

const highlight = (text, target) => text.replace(new RegExp(`(${target})`, "gi"), `<mark>$1</mark>`);
const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

const Input = memo(props => {
  const { provider, autocompleteResults, submitSearch, setQuery, ...rest } = props;
  const logo = getProviderLogo(provider);
  const [isListening, setIsListening] = useState(false);
  const [hasPlaceholder, setHasPlaceholder] = useState(null);
  const [errorPlaceholder, setErrorPlaceholder] = useState(false);
  // enable speech recognition only on supported browsers
  let mic = null;
  if (SpeechRecognition) {
    mic = new SpeechRecognition();
    mic.lang = 'en-US';
  }

  useEffect(() => {
    handleListen();
  }, [isListening]);

  const handleListen = () => {
    if (isListening) {
      mic.start();
    } else if(mic) {
      mic.stop()
      mic.onend = () => {
        setHasPlaceholder(props.placeholder)
      }
    }

    if (mic) {
      mic.onstart = () => {
        setErrorPlaceholder(false);
        setHasPlaceholder('Listening...');
      }
  
      mic.onresult = (event) => {
        setQuery(event.results[0][0].transcript);
        submitSearch(event.results[0][0].transcript);
        mic.stop()
        setIsListening(false);
      }
  
      mic.onerror = (e) => {
        setErrorPlaceholder(true);
        setHasPlaceholder(`Error occurred due to ${e.error}...`);
        mic.stop();
      }
    }
  }

  return (
    <div class={props.searchBarStyle === "1" ? styles.containerStyle1 : styles.container + ' search_container'}>
      {autocompleteResults && autocompleteResults.length > 0 ? (
        <ul>
          {autocompleteResults.slice(0, 10).map(au => (
            <li key={au} dangerouslySetInnerHTML={{ __html: highlight(au, props.value) }} onClick={() => submitSearch(au)} />
          ))}
        </ul>
      ) : null}
      {logo && props.searchBarStyle != "1" && <img src={`${window.GLOBALS.ASSETS.GENERIC}/img/${logo}`} />}
      <input type="search" class={'search_input'} {...rest} value={isListening ? '' : props.value} placeholder={hasPlaceholder || props.placeholder} style={errorPlaceholder && { '--placeholder-color': '#DA5E5E' }} />
      {props.searchBarStyle === "1" ?
        (
          <div class={styles.style1}>
            <svg width="1" height="18" viewBox="0 0 1 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.2" d="M0.5 1L0.499998 41" stroke="#828282" strokeLinecap="square" /></svg>
            {SpeechRecognition &&
              <i onClick={() => setIsListening(!isListening)}>
                <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_20_193)"><path d="M6.49994 11.6553C8.04172 11.6553 9.29004 10.4522 9.29004 8.96623V2.68902C9.29004 1.2031 8.04172 0 6.49994 0C4.95817 0 3.70985 1.2031 3.70985 2.68902V8.96623C3.70985 10.4522 4.95817 11.6553 6.49994 11.6553Z" fill="#0034F5" /><path d="M5.56719 14.7115H7.42871V18H5.56719V14.7115Z" fill="#0034F5" /><path d="M1.83969 9.00007C1.84407 11.4738 3.93336 13.4874 6.50007 13.4874C7.78781 13.4874 8.95729 12.9808 9.80264 12.1619L11.1035 13.4156C9.92528 14.5512 8.30028 15.2562 6.50007 15.2562C2.91281 15.2562 0.00444889 12.4532 6.86646e-05 8.99585H1.83969V9.00007Z" fill="#0034F5" /><path d="M9.80256 12.1618C10.6392 11.3513 11.1604 10.2326 11.1604 9H13C13 10.7223 12.2729 12.2842 11.1034 13.4156L9.80256 12.1618Z" fill="#0034F5" /></g><defs><clipPath id="clip0_20_193"><rect width="13" height="18" fill="white" transform="matrix(-1 0 0 1 13 0)" /></clipPath></defs></svg>
              </i>
            }
            <button type="submit" class={'search_button'}>
              <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path fillRule='evenodd' clipRule='evenodd' d='M12.885 11.8597L17.2131 16.1878C17.4879 16.4723 17.484 16.9246 17.2043 17.2043C16.9246 17.484 16.4723 17.4879 16.1878 17.2131L11.8597 12.885C8.86376 15.3346 4.47323 15.0048 1.87695 12.135C-0.719338 9.26516 -0.609286 4.86363 2.12717 2.12717C4.86363 -0.609286 9.26516 -0.719338 12.135 1.87695C15.0048 4.47323 15.3346 8.86376 12.885 11.8597ZM1.47331 7.27414C1.47331 10.4778 4.07041 13.0749 7.27409 13.0749C10.4763 13.0713 13.0713 10.4763 13.0749 7.27414C13.0749 4.07046 10.4778 1.47336 7.27409 1.47336C4.07041 1.47336 1.47331 4.07046 1.47331 7.27414Z' fill='#0034F5' /></svg>
            </button>
          </div>
        )
        :
        <button type="submit" class={'search_button'}>
          <Icon size={0.75} name="search" searchBarStyle={props.searchBarStyle} />
        </button>
      }
    </div>
  );
});

export default Input;
